import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ProgressBar from './ProgressBar';
import * as styles from './ChallengeCardInProgress.css';

const cx = classNames.bind(styles);

/**
 * Formats a date string as month/year.
 * @param {string} dateStr - ISO date string
 * @returns {string} Formatted date (e.g., "8/2026")
 */
export const formatEndDate = (dateStr) => {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${month}/${year}`;
};

const ChallengeCardInProgress = ({
    challenge,
    urgencyMessage,
    onExclusionsClick,
    progressBarVariant,
}) => {
    const { shortDescription, description, progressCompleted, threshold, endDate } = challenge;
    const isAlmostThere = urgencyMessage && urgencyMessage.type === 'almostThere';
    const isHurry = urgencyMessage && urgencyMessage.type === 'hurry';

    return (
        <div className={cx('challengeCard')}>
            <div className={cx('headingInfo')}>
                <h3 className={cx('title')}>{shortDescription}</h3>
                <p className={cx('description')}>{description}</p>
            </div>
            <div className={cx('progressWrapper')}>
                <ProgressBar
                    progressCompleted={progressCompleted}
                    threshold={threshold}
                    variant={progressBarVariant}
                />
            </div>
            <div className={cx('endDateRow')}>
                <p className={cx('endDate')}>Ends {formatEndDate(endDate)}</p>
                <button
                    type="button"
                    className={cx('exclusionsLink')}
                    onClick={() => onExclusionsClick(challenge)}
                >
                    Exclusions &amp; Details
                </button>
            </div>
            {urgencyMessage && (
                <div className={cx('urgencyBadge', { almostThere: isAlmostThere, hurry: isHurry })}>
                    <p className={cx('urgencyText')}>
                        {typeof urgencyMessage.text === 'string'
                            ? urgencyMessage.text
                            : urgencyMessage.text.map((part, index) =>
                                  part.bold ? (
                                      <span key={index} className={cx('boldText')}>
                                          {part.text}
                                      </span>
                                  ) : (
                                      <span key={index}>{part.text}</span>
                                  )
                              )}
                    </p>
                </div>
            )}
        </div>
    );
};

ChallengeCardInProgress.propTypes = {
    challenge: PropTypes.shape({
        offerId: PropTypes.string,
        shortDescription: PropTypes.string,
        description: PropTypes.string,
        progressCompleted: PropTypes.number,
        threshold: PropTypes.number,
        endDate: PropTypes.string,
        offerTermsAndConditions: PropTypes.string,
    }).isRequired,
    urgencyMessage: PropTypes.shape({
        type: PropTypes.oneOf(['almostThere', 'hurry']).isRequired,
        text: PropTypes.string.isRequired,
    }),
    onExclusionsClick: PropTypes.func.isRequired,
    progressBarVariant: PropTypes.oneOf(['default', 'grey']),
};

ChallengeCardInProgress.defaultProps = {
    urgencyMessage: null,
    progressBarVariant: 'default',
};

export default ChallengeCardInProgress;
